import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TimeInterface } from '../../models/date-time.models';

@Component({
  selector: 'std-time-picker',
  template: ` <div
    (mouseleave)="endGrabEvent($event)"
    (mouseup)="endGrabEvent($event)"
    (touchend)="endGrabEvent($event)"
    (touchcancel)="endGrabEvent($event)"
    [class]="
      'h-max w-[443px] bg-white select-none border-[3px] border-primary rounded-[60px] p-8 ' +
      customClassContainer
    "
    [ngClass]="{
      'cursor-grabbing': grabbedStatus,
    }"
  >
    <div
      class="gap-[20px] items-center mx-auto place-content-center flex mt-[45px]"
    >
      <div
        [class]="
          'h-[60px] w-[160px] border-[2px] border-primary rounded-[19px] shadow-md flex place-content-center ' +
          customClassInput
        "
      >
        <input
          class="text-font40px w-[160px] rounded-[19px] outline-none mx-auto h-[60px] bg-transparent text-center"
          type="number"
          [min]="0"
          [max]="use24h ? 23 : 11"
          [(ngModel)]="h"
          (change)="
            h < 0 ? (h = 0) : null;
            h > (use24h ? 23 : 11) ? (h = use24h ? 23 : 11) : null;
            emitNewTime()
          "
        />
      </div>
      <div
        class="text-primary font-bold text-font60px leading-[60px] flex items-center place-content-center pb-[20px]"
      >
        :
      </div>
      <div
        [class]="
          'h-[60px] w-[160px] border-[2px] border-primary rounded-[19px] shadow-md flex place-content-center ' +
          customClassInput
        "
      >
        <input
          class="text-font40px w-[160px] rounded-[19px] outline-none mx-auto h-[60px] bg-transparent text-center"
          type="number"
          [min]="0"
          [max]="59"
          contro
          [(ngModel)]="m"
          (change)="m > 59 ? (m = 59) : null; emitNewTime()"
        />
      </div>
    </div>
    @if(!use24h){
    <div
      class="flex mx-auto gap-[14px] mt-[25px] mb-[35px] place-content-center"
    >
      <div
        (click)="time = 'am'; emitNewTime()"
        class="text-secondary text-font30px cursor-pointer"
        [ngClass]="{
          'text-primary font-bold': time == 'am',
          'text-secondary': time !== 'am'
        }"
      >
        AM
      </div>
      <div
        (click)="time = 'pm'; emitNewTime()"
        class="text-secondary text-font30px cursor-pointer"
        [ngClass]="{
          'text-primary font-bold': time == 'pm',
          'text-secondary': time !== 'pm'
        }"
      >
        PM
      </div>
    </div>
    } @if(showClock){
    <div
      [class]="
        'mx-auto my-[15px] flex items-center place-content-center size-[300px] rounded-full border-[2px] border-primary shadow-lg ' +
        customClassClock
      "
    >
      <div class="size-2 rounded-full flex items-center place-content-center">
        <div
          class="size-[9px] bg-primary rounded-full flex items-center place-content-center"
        >
          @for (item of [9,10,11,12,13,14,15,16,17,18,19,20]; track $index) {
          <div
            [style]="'transform:rotate(' + (360 / 12) * item + 'deg)'"
            class="relative size-0 flex items-center place-content-center"
          >
            <div
              class="h-[35px] left-0 w-[135px] absolute bg-transparent flex items-center"
              (mouseenter)="changeTime($index)"
            >
              <div
                [style]="'transform:rotate(' + (360 / 12) * item * -1 + 'deg)'"
                [id]="'timeH-location-' + id + '-' + $index"
                [ngClass]="{
                  '!bg-primary text-tertiary rounded-full':
                    $index == h || 12 + $index == h,
                  'text-secondary': $index !== h
                }"
                [class]="
                  'ml-auto rounded-full flex items-center place-content-center text-large size-[30px] ' +
                  customClassNumbers
                "
              >
                {{
                  use24h
                    ? h == 11 && $index == 0
                      ? 12
                      : h > 11
                      ? h == 12 && $index == 11
                        ? 11
                        : $index + 12
                      : $index
                    : $index == 0
                    ? 12
                    : $index
                }}
              </div>
            </div>
          </div>
          }

          <div
            class="relative size-0 flex items-center place-content-center cursor-grab"
            [style]="'transform:rotate(' + ((360 / 60) * m - 90) + 'deg)'"
          >
            <div
              class="h-[35px] left-0 w-[95px] absolute flex items-center"
              (mouseup)="endGrabEvent($event)"
              (mousedown)="
                startGrabEvent($event, 'time-picker-event-id-' + id, 'm')
              "
              (click)="$event.stopPropagation()"
              [ngClass]="{
                'cursor-grabbing pointer-events-none': grabbedStatus
              }"
            >
              @if(baseStyle == 'primary'){ @if(useCustomArrows) {
              <ng-content select="[minute-arrow]"></ng-content>}
              @if(!useCustomArrows){
              <svg
                width="92"
                height="24"
                viewBox="0 0 92 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M91.0607 13.0607C91.6464 12.4749 91.6464 11.5251 91.0607 10.9393L81.5147 1.3934C80.9289 0.807612 79.9792 0.807612 79.3934 1.3934C78.8076 1.97918 78.8076 2.92893 79.3934 3.51472L87.8787 12L79.3934 20.4853C78.8076 21.0711 78.8076 22.0208 79.3934 22.6066C79.9792 23.1924 80.9289 23.1924 81.5147 22.6066L91.0607 13.0607ZM0 12L0 13.5L90 13.5V12V10.5L0 10.5L0 12Z"
                  class="fill-primary"
                />
              </svg>
              } } @if(baseStyle == 'secondary'){
              <div
                class="ml-auto size-[30px] flex items-center place-content-center relative left-[5px] rounded-full bg-red-300 border-[1px] border-black"
              >
                <div
                  class="text-center"
                  [style]="
                    'transform:rotate(' + ((360 / 60) * m - 90) * -1 + 'deg)'
                  "
                >
                  {{ m }}
                </div>
              </div>
              }
            </div>
          </div>
          <div
            class="relative size-0 flex items-center place-content-center"
            [style]="'transform:rotate(' + ((360 / 12) * h - 90) + 'deg)'"
          >
            <div
              (mouseup)="endGrabEvent($event)"
              (mousedown)="
                startGrabEvent($event, 'time-picker-event-id-' + id, 'h')
              "
              class="h-[25px] left-0 w-[75px] absolute flex items-center cursor-grab"
              [ngClass]="{
                'cursor-grabbing  pointer-events-none': grabbedStatus
              }"
            >
              @if(baseStyle == 'primary'){ @if(useCustomArrows){
              <ng-content select="[hour-arrow]"></ng-content>}
              @if(!useCustomArrows){
              <svg
                width="68"
                height="16"
                viewBox="0 0 68 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M67.7071 8.70711C68.0976 8.31658 68.0976 7.68342 67.7071 7.29289L61.3431 0.928932C60.9526 0.538408 60.3195 0.538408 59.9289 0.928932C59.5384 1.31946 59.5384 1.95262 59.9289 2.34315L65.5858 8L59.9289 13.6569C59.5384 14.0474 59.5384 14.6805 59.9289 15.0711C60.3195 15.4616 60.9526 15.4616 61.3431 15.0711L67.7071 8.70711ZM0 8V9H67V8V7H0V8Z"
                  class="fill-primary"
                />
              </svg>
              } } @if(baseStyle == 'secondary'){
              <div
                class="ml-auto size-[30px] flex items-center place-content-center relative left-[5px] rounded-full bg-red-300 border-[1px] border-black"
              >
                <div
                  class="text-center"
                  [style]="
                    'transform:rotate(' + ((360 / 12) * h - 90) * -1 + 'deg)'
                  "
                >
                  {{ h }}
                </div>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    }
    <ng-content select="[footer]"></ng-content>
  </div>`,
  styles: `
  input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
  `,
  standalone: false,
})
export class TimePickerComponent implements OnInit {
  constructor() {}

  @Input() h = 0;
  @Input() m = 0;
  @Input() startingTime: string = '';
  @Input() time: 'am' | 'pm' = 'am';
  @Input() id = 'base';
  @Input() baseStyle: 'primary' | 'secondary' = 'primary';
  @Input() customClassContainer: string = '';
  @Input() customClassClock: string = '';
  @Input() customClassNumbers: string = '';
  @Input() customClassInput: string = '';
  @Input() useCustomArrows: boolean = false;
  @Input() use24h: boolean = false;
  @Input() showClock: boolean = true;
  @Input() step5Minutes: boolean = false;
  @Output() changeDate: EventEmitter<TimeInterface> =
    new EventEmitter<TimeInterface>();
  grabbedStatus = false;
  grabbedX: number = 0;
  grabbedY: number = 0;
  tempH = -1;
  tempM = -1;
  grabbed = '';

  ngOnInit(): void {
    if (this.startingTime) {
      let h = parseInt(this.startingTime.slice(0, 2));
      if (this.use24h) {
        this.h = h;
      } else {
        if (h > 11) {
          this.time = 'pm';
          this.h = h - 12;
        } else {
          this.h = h;
        }
      }
      this.m = parseInt(this.startingTime.slice(3, 5));
    }
  }

  changeTime(time: number) {
    if (this.grabbedStatus && this.grabbed == 'm') {
      this.m = time * 5;
      this.emitNewTime();
    }
    if (this.grabbedStatus && this.grabbed == 'h') {
      if (this.h == 11 && time == 0) {
        this.h = 12;
      }
      if (this.h >= 12 && time != 11) {
        this.h = time + 12;
      }
      if (this.h == 22 && time == 11) {
        this.h = 23;
      }
      if (this.h == 12 && time == 11) {
        this.h = 11;
      }
      if (this.h < 12 && time != 0) {
        this.h = time;
      }
      if (this.h == 1 && time == 0) {
        this.h = 0;
      }

      this.emitNewTime();
    }
  }

  emitNewTime() {
    if (this.m < 0) {
      this.m = 0;
    }
    this.m = Math.ceil(this.m);
    if (this.step5Minutes) {
      if (Math.ceil(this.m) % 5 >= 3) {
        this.m = this.m + (5 - (Math.ceil(this.m) % 5));
      } else {
        this.m = this.m - (Math.ceil(this.m) % 5);
      }
      if (this.m === 60) {
        this.m = 59;
      }
    }
    this.h = Math.ceil(this.h);
    let hours: string | number = this.time == 'pm' ? this.h + 12 : this.h;
    hours = hours > 9 ? hours : '0' + hours;
    let minutes = this.m > 9 ? this.m : '0' + this.m;
    this.changeDate.emit({
      h: this.h,
      m: this.m,
      time: this.time,
      formattedTime: `${hours}:${minutes}`,
    });
  }

  endGrabEvent(event: any) {
    this.grabbedStatus = false;
  }

  startGrabEvent(event: any, eventId: string, grabbed: string) {
    this.grabbedX = event.clientX;
    this.grabbedY = event.clientY;
    this.grabbedStatus = true;
    this.grabbed = grabbed;
  }
}
